var r=function(r,n){return r[n]};export{r as selectToken};
//# sourceMappingURL=selectToken.js.map
